//
// locales/vanilla/ro.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/ro.json';
import localeData from 'react-intl/locale-data/ro.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
